

// import React from "react";
// import { IoDocumentText, IoChevronDown } from "react-icons/io5";
// import { FaDatabase } from "react-icons/fa";
// import { MdEditDocument } from "react-icons/md";
// import * as FiIcons from "react-icons/fi";
// import * as HiIcons from "react-icons/hi";
// import * as FaIcons from "react-icons/fa";
// import * as IoIcons from "react-icons/io5";

// // ── Utility: resolve icon by name ──────────────────────────────────────────────
// export const getIcon = (iconName) => {
//     if (!iconName) return null;
//     const name = iconName.trim();
//     return FiIcons[name] || HiIcons[name] || FaIcons[name] || IoIcons[name] || null;
// };

// // ── Category → { icon, color } mapping ─────────────────────────────────────────
// // Add/rename entries here to match your real service_name values.
// // Falls back to a neutral icon/color if a name isn't listed.
// const CATEGORY_STYLES = {
//     "Masters": { icon: FiIcons.FiSettings, color: "#5B5FEF" },
//     "Data Entry": { icon: FiIcons.FiEdit3, color: "#0EA5A5" },
//     "Reports": { icon: FiIcons.FiBarChart2, color: "#D97706" },
//     "Change Password": { icon: FiIcons.FiLock, color: "#64748B" },
//     "Portal Admin": { icon: FiIcons.FiShield, color: "#E1476C" },
// };

// const DEFAULT_STYLE = { icon: IoDocumentText, color: "#6B7280" };

// const getCategoryStyle = (serviceName) =>
//     CATEGORY_STYLES[serviceName] || DEFAULT_STYLE;

// // ── Collapsible Parent Section ─────────────────────────────────────────────────
// // NOTE: `open` is no longer local state. It is fully controlled by the parent
// // (MenuBar / RusaDashboard) via `isOpen` + `onToggle`, so that only one
// // parent section can be expanded at a time (true accordion behaviour).
// export function ParentSection({ parent, kids, activeMenu, onSelect, sidebarOpen, isOpen, onToggle }) {
//     const hasActiveChild = kids.some((k) => k.service_name === activeMenu);

//     const { icon: ParentIcon, color } =
//         getCategoryStyle(parent.service_name) ||
//         { icon: getIcon(parent.icon) || IoDocumentText, color: DEFAULT_STYLE.color };

//     return (
//         <li className="parent-menu">
//             <div
//                 className={`parent-title ${hasActiveChild ? "parent-has-active" : ""}`}
//                 style={{ "--accent": color }}
//                 role="button"
//                 tabIndex={0}
//                 aria-expanded={isOpen}
//                 onClick={onToggle}
//                 onKeyDown={(e) => {
//                     if (e.key === "Enter" || e.key === " ") {
//                         e.preventDefault();
//                         onToggle();
//                     }
//                 }}
//             >
//                 <span className="parent-icon-badge" style={{ background: `${color}1A`, color }}>
//                     <ParentIcon size={16} />
//                 </span>

//                 {sidebarOpen && <span className="parent-label">{parent.service_name}</span>}

//                 {sidebarOpen && (
//                     <IoChevronDown
//                         size={14}
//                         className={`parent-arrow ${isOpen ? "rotated" : ""}`}
//                     />
//                 )}
//             </div>

//             {isOpen && (
//                 <div
//                     className="children-wrapper"
//                     style={{ maxHeight: `${kids.length * 44 + 8}px` }}
//                 >
//                     {/* {kids.map((child) => {
//                         const ChildIcon = getIcon(child.icon) || FaDatabase;
//                         const childPath = child.target || child.service_name;
//                         const isActive = activeMenu === child.service_name;
//                         return (
//                             <div
//                                 key={child.service_id}
//                                 className={`child-item ${isActive ? "active" : ""}`}
//                                 style={{ "--accent": color }}
//                                 role="button"
//                                 tabIndex={0}
//                                 onClick={() => onSelect(childPath)}
//                                 onKeyDown={(e) => {
//                                     if (e.key === "Enter" || e.key === " ") {
//                                         e.preventDefault();
//                                         onSelect(childPath);
//                                     }
//                                 }}
//                             >
//                                 <ChildIcon size={14} className="child-icon" />
//                                 <span className="child-itemnew ellipsis-text">{child.service_name}</span>
//                             </div>
//                         );
//                     })} */}

//                     {kids.map((child) => {
//                         const ChildIcon = getIcon(child.icon);
//                         const childPath = child.target || child.service_name;
//                         const isActive = activeMenu === child.service_name;

//                         return (
//                             <div
//                                 key={child.service_id}
//                                 className={`child-item ${isActive ? "active" : ""}`}
//                                 style={{ "--accent": color }}
//                                 role="button"
//                                 tabIndex={0}
//                                 onClick={() => onSelect(childPath)}
//                                 onKeyDown={(e) => {
//                                     if (e.key === "Enter" || e.key === " ") {
//                                         e.preventDefault();
//                                         onSelect(childPath);
//                                     }
//                                 }}
//                             >
//                                 {ChildIcon && <ChildIcon size={14} className="child-icon" />}

//                                 <span className="child-itemnew ellipsis-text">
//                                     {child.service_name}
//                                 </span>
//                             </div>
//                         );
//                     })}

//                 </div>
//             )}
//         </li>
//     );
// }

// // ── Unified MenuItem: dropdown if has kids, else direct route ──────────────────
// export function MenuItem({ item, kids, activeMenu, onSelect, sidebarOpen, defaultIcon, isOpen, onToggle }) {
//     const { icon: MappedIcon, color } = getCategoryStyle(item.service_name);
//     const ItemIcon = MappedIcon || getIcon(item.icon) || defaultIcon || MdEditDocument;

//     if (kids && kids.length > 0) {
//         return (
//             <ParentSection
//                 parent={item}
//                 kids={kids}
//                 activeMenu={activeMenu}
//                 onSelect={onSelect}
//                 sidebarOpen={sidebarOpen}
//                 isOpen={isOpen}
//                 onToggle={onToggle}
//             />
//         );
//     }

//     const isActive = activeMenu === item.service_name;

//     return (
//         <li
//             className={`single-menu ${isActive ? "active" : ""}`}
//             style={{ "--accent": color }}
//             role="button"
//             tabIndex={0}
//             onClick={() => onSelect(item.target)}
//             onKeyDown={(e) => {
//                 if (e.key === "Enter" || e.key === " ") {
//                     e.preventDefault();
//                     onSelect(item.target);
//                 }
//             }}
//         >
//             <span className="parent-icon-badge" style={{ background: `${color}1A`, color }}>
//                 <ItemIcon size={16} />
//             </span>
//             {sidebarOpen && <span className="child-itemnew">{item.service_name}</span>}
//         </li>
//     );
// }

// export const showValue = (value) => (value ? value : "-");


import React from "react";
import { IoDocumentText, IoChevronDown } from "react-icons/io5";
import { FaDatabase } from "react-icons/fa";
import { MdEditDocument } from "react-icons/md";
import * as FiIcons from "react-icons/fi";
import * as HiIcons from "react-icons/hi";
import * as FaIcons from "react-icons/fa";
import * as IoIcons from "react-icons/io5";

// ── Utility: resolve icon by name ──────────────────────────────────────────
export const getIcon = (iconName) => {
    if (!iconName) return null;
    const name = iconName.trim();
    return FiIcons[name] || HiIcons[name] || FaIcons[name] || IoIcons[name] || null;
};

// ── Category → { icon, color } mapping ──────────────────────────────────────
const CATEGORY_STYLES = {
    "Masters": { icon: FiIcons.FiSettings, color: "#5B5FEF" },
    "Data Entry": { icon: FiIcons.FiEdit3, color: "#0EA5A5" },
    "Reports": { icon: FiIcons.FiBarChart2, color: "#D97706" },
    "Change Password": { icon: FiIcons.FiLock, color: "#64748B" },
    "Portal Admin": { icon: FiIcons.FiShield, color: "#E1476C" },
};

const DEFAULT_STYLE = { icon: IoDocumentText, color: "#6B7280" };

const getCategoryStyle = (serviceName) =>
    CATEGORY_STYLES[serviceName] || DEFAULT_STYLE;

// ── Collapsible Parent Section ───────────────────────────────────────────────
// `open` is fully controlled by the parent (MenuBar / RusaDashboard) via
// `isOpen` + `onToggle`, so that only one parent section can be expanded
// at a time (true accordion behaviour).
export function ParentSection({ parent, kids, activeMenu, onSelect, sidebarOpen, isOpen, onToggle }) {
    const hasActiveChild = kids.some((k) => k.service_name === activeMenu);

    const { icon: ParentIcon, color } =
        getCategoryStyle(parent.service_name) ||
        { icon: getIcon(parent.icon) || IoDocumentText, color: DEFAULT_STYLE.color };

    return (
        <li className="parent-menu">
            <div
                className={`parent-title ${hasActiveChild ? "parent-has-active" : ""}`}
                style={{ "--accent": color }}
                role="button"
                tabIndex={0}
                aria-expanded={isOpen}
                onClick={onToggle}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onToggle();
                    }
                }}
            >
                <span className="parent-icon-badge" style={{ background: `${color}1A`, color }}>
                    <ParentIcon size={16} />
                </span>

                {sidebarOpen && <span className="parent-label">{parent.service_name}</span>}

                {sidebarOpen && (
                    <IoChevronDown
                        size={14}
                        className={`parent-arrow ${isOpen ? "rotated" : ""}`}
                    />
                )}
            </div>

            {isOpen && (
                <div
                    className="children-wrapper"
                    style={{ maxHeight: `${kids.length * 44 + 8}px` }}
                >
                    {kids.map((child) => {
                        const ChildIcon = getIcon(child.icon);
                        const childPath = child.service_name;
                        const isActive = activeMenu === child.service_name;

                        return (
                            <div
                                key={child.service_id}
                                className={`child-item ${isActive ? "active" : ""}`}
                                style={{ "--accent": color }}
                                role="button"
                                tabIndex={0}
                                onClick={() => onSelect(childPath)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        onSelect(childPath);
                                    }
                                }}
                            >
                                {ChildIcon && <ChildIcon size={14} className="child-icon" />}
                                <span className="child-itemnew ellipsis-text">
                                    {child.service_name}
                                </span>
                            </div>
                        );
                    })}
                </div>
            )}
        </li>
    );
}

// ── Unified MenuItem: dropdown if has kids, else direct route ────────────────
export function MenuItem({ item, kids, activeMenu, onSelect, sidebarOpen, defaultIcon, isOpen, onToggle }) {
    const { icon: MappedIcon, color } = getCategoryStyle(item.service_name);
    const ItemIcon = MappedIcon || getIcon(item.icon) || defaultIcon || MdEditDocument;

    if (kids && kids.length > 0) {
        return (
            <ParentSection
                parent={item}
                kids={kids}
                activeMenu={activeMenu}
                onSelect={onSelect}
                sidebarOpen={sidebarOpen}
                isOpen={isOpen}
                onToggle={onToggle}
            />
        );
    }

    const isActive = activeMenu === item.service_name;

    return (
        <li
            className={`single-menu ${isActive ? "active" : ""}`}
            style={{ "--accent": color }}
            role="button"
            tabIndex={0}
            onClick={() => onSelect(item.service_name)}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onSelect(item.service_name);
                }
            }}
        >
            <span className="parent-icon-badge" style={{ background: `${color}1A`, color }}>
                <ItemIcon size={16} />
            </span>
            {sidebarOpen && <span className="child-itemnew">{item.service_name}</span>}
        </li>
    );
}

export const showValue = (value) => (value ? value : "-");